import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DownloadService } from './../../download/download.service';
var DashboardDownloadStatComponent = (function () {
    function DashboardDownloadStatComponent(downloadService) {
        this.downloadService = downloadService;
        this.barChartOptions = {
            responsive: true
        };
        this.barChartLabels = [
            'มกราคม',
            'กุมภาพันธ์',
            'มีนาคม',
            'เมษายน',
            'พฤษภาคม',
            'มิถุนายน',
            'กรกฎาคม',
            'สิงหาคม',
            'กันยายน',
            'ตุลาคม',
            'พฤศจิกายน',
            'ธันวาคม'
        ];
        this.barChartType = 'bar';
        this.barChartPlugins = [];
        this.barChartData = [
            { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'ข้อมูลคำร้องขอดูเอกสาร' }
        ];
    }
    DashboardDownloadStatComponent.prototype.ngOnInit = function () {
        this.getDocumentDownloadList();
    };
    DashboardDownloadStatComponent.prototype.getDocumentDownloadList = function () {
        var _this = this;
        var params = new HttpParams().set('none_pagination', 'True');
        this.downloadService.getDocumentRequestList(params).subscribe(function (res) {
            res.map(function (o) { return (o['month'] = moment(o.created_at).format('M')); });
            var data = _.groupBy(res, 'month');
            _this.barChartData = [
                data['1'] ? data['1'].length : 0,
                data['2'] ? data['2'].length : 0,
                data['3'] ? data['3'].length : 0,
                data['4'] ? data['4'].length : 0,
                data['5'] ? data['5'].length : 0,
                data['6'] ? data['6'].length : 0,
                data['7'] ? data['7'].length : 0,
                data['8'] ? data['8'].length : 0,
                data['9'] ? data['9'].length : 0,
                data['10'] ? data['10'].length : 0,
                data['11'] ? data['11'].length : 0,
                data['12'] ? data['12'].length : 0
            ];
        }, function (error) { return console.log('error', error); });
    };
    return DashboardDownloadStatComponent;
}());
export { DashboardDownloadStatComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-download-stat/dashboard-download-stat.component.ts.pre-build-optimizer.js